<template>
  <button class="footer-share_item" @click="openShare('https://www.facebook.com/PDappofficial')">
    <img src="@/assets/share/facebookIcon.svg" :alt="typeViteEnv('VITE_BASE_STATE_TITLE') as string" />
  </button>
  <button class="footer-share_item" @click="openShare('https://twitter.com/PeoplesDailyapp')">
    <img src="@/assets/share/twitterIcon.svg" :alt="typeViteEnv('VITE_BASE_STATE_TITLE') as string" />
  </button>
  <button class="footer-share_item" @click="openShare('https://www.youtube.com/@chinaeverything4712')">
    <img src="@/assets/share/YouTube.svg" :alt="typeViteEnv('VITE_BASE_STATE_TITLE') as string" />
  </button>
  <button class="footer-share_item" @click="openShare('https://www.tiktok.com/@peoplesdaily_renminribao')">
    <img src="@/assets/share/tiktok.svg" :alt="typeViteEnv('VITE_BASE_STATE_TITLE') as string" />
  </button>
</template>

<script setup lang="ts">
import { typeViteEnv } from '@/utils/env'

const openShare = (val: string) => {
  window.open(val)
}
</script>

<style lang="less" scoped>
.footer-share_item {
  width: 38px;
  height: 38px;
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
  border-radius: 50%;
  
  img {
    width: 38px;
    height: 38px;
  }
}
</style>
